import { graphql } from '@/gql'

export const MilestonesQuery = graphql(/* GraphQL */ `
  query MilestonesQuery($accountId: ID!, $hireId: ID!) {
    milestones(accounts: [$accountId], hires: [$hireId]) {
      data {
        ...MilestoneType
      }
    }
    hire(id: $hireId) {
      id
      currency
    }
  }
`)
